import FieldRenderer from "../global/forms/FieldRenderer";
import OrganizationFieldsProps from "../../services/models/formModels/organizationSignUpFields.model";
import useStateAndCity from "../../services/utils/custom hooks/useStateAndCity";
import { optionType } from "../organism/CustomSelect";
import dataConstants from "../../constants/dataConstants";
import useProfile from "../../services/utils/custom hooks/useProfile";

function OrganizationFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  isSignUpFlow,
  setFieldValue,
  values,
  getFieldMeta,
  setFieldError,
  isUpdating,
}: OrganizationFieldsProps): JSX.Element {
  const { data } = useStateAndCity();
  const stateCities = data?.find((state: any) => {
    if (isSignUpFlow) return state.state_code === values?.org?.state;
    return state.state_code === values.state;
  })?.cities;
  const cities = stateCities?.map(
    (city: any): optionType => ({ label: city.name, value: city.name })
  );
  const { data: profile, isLoading: fetchingProfile } = useProfile();
  const states: optionType[] = data?.map((state: any) => ({
    label: state.name,
    value: state.state_code,
  }));

  return (
    <div>
      {/* Render other fields using FieldRenderer */}
      <FieldRenderer
        fields={dataConstants.orgFields
          .filter(
            (field) =>
              !(
                (field.name === "logo" ||
                  field.name == "email" ||
                  field.name === "cbsTests") &&
                isSignUpFlow
              )
          )
          .map((field, index) => {
            if (field.name === "city" || field.name === "state") {
              return {
                ...field,
                labelInfo: {
                  ...field.labelInfo,
                  inputId: isSignUpFlow ? `org.${field.name}` : field.name,
                },
                setFieldValue: setFieldValue,
                key: `${index}${field.labelInfo?.inputId}`,
                errors: errors,
                values,
                getFieldMeta,
                setFieldError,
                touched: touched,
                onChange: handleChange,
                value: isSignUpFlow
                  ? values?.org?.[!!field.name ? field.name : ""]
                  : values?.[!!field?.name ? field.name : ""],
                onBlur: handleBlur,
                name: isSignUpFlow ? `org.${field.name}` : field.name,
                roundedInput: true,
                checkBoxClassName: "inline-block mr-3",
                parentContainerClass:
                  ["phone", "fax"].includes?.(field?.name ? field.name : "") &&
                  !isSignUpFlow
                    ? " md:!w-[49%]"
                    : ["cbsTests"].includes?.(field?.name ? field.name : "")
                    ? `${field.parentContainerClass} xs:w-[90vw] md:w-auto mb-3`
                    : `${field.parentContainerClass}`,
                suggestions: field.name === "state" ? states : cities,
                disabled: isUpdating,
              };
            }
            return {
              ...field,
              labelInfo: {
                ...field.labelInfo,
                inputId: isSignUpFlow ? `org.${field.name}` : field.name,
              },
              setFieldValue: setFieldValue,
              key: `${index}${field.labelInfo?.inputId}`,
              errors: errors,
              values,
              getFieldMeta,
              setFieldError,
              touched: touched,
              onChange: handleChange,
              value: isSignUpFlow
                ? values?.org?.[!!field.name ? field.name : ""]
                : values?.[!!field?.name ? field.name : ""],
              onBlur: handleBlur,
              name: isSignUpFlow ? `org.${field.name}` : field.name,
              roundedInput: true,
              checkboxesContainerClassName: "flex flex-wrap md:flex-nowrap items-center",
              parentContainerClass:
                ["phone", "fax"].includes?.(field?.name ? field.name : "") &&
                !isSignUpFlow
                  ? "md:!w-[49%]"
                  : ["cbsTests"].includes?.(field?.name ? field.name : "")
                  ? `${field.parentContainerClass} xs:w-[90vw] md:w-auto mb-3`
                  : `${field.parentContainerClass}`,
              disabled: isUpdating && field.name !== "cbsTests",
            };
          })}
      />
    </div>
  );
}

export default OrganizationFields;
